import { api } from '@/services/axios.service';
import type { Challenge } from 'altcha-lib/types';
import type { AltchaVerifiedPayload } from '@/models/altcha.model';

export const getPublicChallenge = async () =>
    (await api.get<Challenge>(`${import.meta.env.VITE_API_BASE_URL}/security/public-challenge`)).data;

export const validateChallenge = async (payload: AltchaVerifiedPayload, solution: string) =>
    (
        await api.post<{
            access_token: string;
        }>(`${import.meta.env.VITE_API_BASE_URL}/security/public-challenge`, {
            challenge: payload.detail.payload,
            solution,
        })
    ).data.access_token;
